declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export function trackEvent(eventName: string, params?: Record<string, unknown>): void {
  if (!window.dataLayer) return;
  window.dataLayer.push({ event: eventName, ...params });
}
